export default {
  // 顶部工具栏
  projectArea: 'Project Area',
  selectRegionPlaceholder: 'Please select parent menu',

  // 分屏模式
  singleScreen: 'Single Screen',
  quadScreen: 'Quad Screen',
  nineScreen: 'Nine Screen',

  // 加载状态
  loading: 'Loading...',

  // 播放器配置
  loadingText: 'Loading',
  watermarkText: 'Live Stream',

  // 质量选项
  qualityAdaptive: 'Adaptive',
  qualitySmooth: 'Smooth',
  qualityStandard: 'Standard',
  qualityHD: 'HD',
  qualityUHD: 'UHD',

  // 提示信息
  noVideoSource: 'No video source',
  selectDeviceFirst: 'Please select a device first',
}
